module.exports = __webpack_public_path__ + "img/foursome-tepeji.64f040b8.png";